import { Avatar, Group, Paper, Stack, Text } from '@mantine/core'
import { useTopArenaPosters } from './api'
import classes from './TopPosters.module.css'

function getInitials(name: string): string {
  const parts = name.split(' ')
  const first = parts[0]?.charAt(0)?.toUpperCase() || ''
  const last = parts[parts.length - 1]?.charAt(0)?.toUpperCase() || ''
  return `${first}${last}` || ''
}

export default function TopPosters() {
  const { data: topPosters } = useTopArenaPosters(10)

  return (
    <Paper className={classes.container}>
      <Text className={classes.title}>Top Posters</Text>

      <Stack className={classes.postersList} gap={0}>
        {topPosters.map((poster) => (
          <Group
            key={poster.user_id}
            className={classes.posterItem}
            gap="xs"
            wrap="nowrap"
          >
            <Avatar size="sm" src={poster.photo} radius="xl" color="primary">
              {getInitials(poster.name)}
            </Avatar>
            <Text className={classes.posterName} truncate>
              {poster.name}
            </Text>
          </Group>
        ))}
      </Stack>
    </Paper>
  )
}
